export enum SearchOptionsEnum {
userName='Name',
email="E-mail",
clinicId="Clinic ID"
}
